import React from 'react';
import ChipsStyled from '../../asset/styled/component/ChipsStyled';

const Chips = ({ children, color, size, variant, onClick }) => {
  return (
    <ChipsStyled color={color} size={size} variant={variant} onClick={onClick}>
      {children}
    </ChipsStyled>
  );
};

export default Chips;
